import { WidgetsServicesReportFormMain } from '@/widgets/services-report-form';

export const PagesServicesProverkaFormMain = () => (
  <WidgetsServicesReportFormMain reportType="PROVERKA" />
);
